module.exports = __webpack_public_path__ + "img/githubactions.c7bcdd03.svg";